module.exports = __webpack_public_path__ + "static/img/FigmaDDSSlicePNG6a04c50883a9f89d8f64afd4a665fe4a.6a04c508.png";